import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import { clientUserShortIdAtom } from '../../state';
import { useGetPublicPatient } from '../../useGetPublicPatientByShortId';

export function useGetClientUserShortId() {
  const appointmentClientUserShortId = useAtomValue(clientUserShortIdAtom);
  const { patientShortId } = useParams() as { patientShortId: string };

  // client user short ID is required to look up measures, but when we don't have a connection between the patient and client user id when there is not an associated appointment
  const { data: publicPatientData } = useGetPublicPatient(appointmentClientUserShortId ? undefined : patientShortId);
  const clientUserShortId = (appointmentClientUserShortId || publicPatientData?.publicPatient?.clientUserShortId) ?? '';

  return clientUserShortId;
}
